import { Capacitor } from "@capacitor/core";
import { defineNuxtPlugin, useFetch } from "nuxt/app";
import { R3FetchDataAxiosImpl } from "~/R3/R3Fetching/axios";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";

//const instance : R3FetchDataInterface = new R3FetchDataAxiosImpl("http://192.168.217.12:3335");
export type R3FetchConnectionConfig = {
	url: string;
	port: number;
}


export default defineNuxtPlugin(async (nuxtApp) => {
	const deviceStore = useDeviceStore();
	const config = useRuntimeConfig();
	const executionTarget = Capacitor.isNativePlatform() ? "capacitor" : "web";

	deviceStore.setExecutionTarget(executionTarget);
	deviceStore.setPlatform(Capacitor.getPlatform() as "web" | "ios" | "android");

	// Verificando se tem conexão com o servidor, caso não tenha, mostrar um dialog de erro

	let baseUrl = config.public.API_URL_EXTERNAL || config.public.API_URL || "";

	if (executionTarget === "capacitor") {
		try {
			const fileResult = await Filesystem.readFile({
				path: "secrets/connectionConfig.json",
				directory: Directory.Cache,
				encoding: Encoding.UTF8,
			});
			const connectionConfig = JSON.parse(String(fileResult.data)) as R3FetchConnectionConfig;
			baseUrl = `${connectionConfig.url}:${connectionConfig.port}`;
		} catch (error) {
			console.warn("Falha ao ler connectionConfig.json no Capacitor. Usando fallback do runtimeConfig.", error);
		}
	}

	if (executionTarget === "web") {
		// Em desenvolvimento podemos apontar diretamente para a API publicada na rede.
		// Isso evita que uma falha do proxy do Nuxt bloqueie a escolha de Empresa no login.
		// Sem URL local configurada (como em produção), mantém o proxy relativo.
		baseUrl = config.public.API_URL_LOCAL || "/proxy";
	}

	const instance = new R3FetchDataAxiosImpl(baseUrl);



	return {
		provide: {
			r3fetchdata: instance,
		},
	};
});

